import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as noticeApi from '../../lib/api/notice';

const [
  LIST_NOTICE_FILES,
  LIST_NOTICE_FILES_SUCCESS,
  LIST_NOTICE_FILES_FAILURE,
] = createRequestActionTypes('dashboard/LIST_NOTICE_FILES');

export const listNoticeFiles = createAction(
  LIST_NOTICE_FILES,
  (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);
const listNoticeFilesSaga = createRequestSaga(
  LIST_NOTICE_FILES,
  noticeApi.getNoticeFiles
);

const UNLOAD_NOTICE_FILES = 'dashboard/UNLOAD_NOTICE_FILES';
export const unloadNoticeFiles = createAction(UNLOAD_NOTICE_FILES);

export function* noticeFilesSaga() {
  yield takeLatest(LIST_NOTICE_FILES, listNoticeFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const noticeFiles = handleActions(
  {
    [LIST_NOTICE_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,//notice
        fileAttrVal1: file.fileAttrVal1, //noticeId
        fileAttrVal2: file.fileAttrVal2,
        fileAttrVal3: file.fileAttrVal3,
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        crtNm: file.crtNm,
        crtDt: file.crtDt,
        cngNm: file.cngNm,
        cngDt: file.cngDt,
      })),
      error: null,
    }),
    [LIST_NOTICE_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_NOTICE_FILES]: () => initialState,
  },
  initialState,
);

export default noticeFiles;
